import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the MetricPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'metric',
})
export class MetricPipe implements PipeTransform {
  /**
   * Takes a value in meters and converts it in km if needed.
   */
  transform(value: number, ...args) {
    if (value === -1 || value === null) {
      return '-- km';
    }
    if (value > 1000) {
      const km = value / 1000;
      return km.toFixed() + ' km';
    }
    return value.toFixed() + ' m';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/metric/metric.ts